<template>
  <div class="order-detail-help-content">
    <div v-if="showPhoneContact" class="content-block" @click="contactBranch">
      <div class="content-block__context">
        <div class="wd-flex wd-flex-nowrap wd-justify-between">
          <span>{{ $t('booking_detail_contact_merchant') }}</span>
          <span class="sm:(wd-px-4)">
            <FunnowSvgIcon max-width="20" height="20" image-path="phone.svg" />
          </span>
        </div>
        <div v-show="isFunBookPlatform" class="wd-mt-4 wd-text-osm wd-text-gray80">
          {{ $t('booking_detail_contact_merchant_content') }}
        </div>
      </div>
    </div>

    <contact-us-modal ref="contactUsModal" />
  </div>
</template>

<script>
import ContactUsModal from '@/components/dialog/orders/contact-us-modal.vue'
import FunnowSvgIcon from '@/components/icons/funnow-svg-icon.vue'
import { useOrderFlags } from '@/composition/useOrder'
import { OrderSource } from '@/view-models/order'

export default defineComponent({
  name: 'OrderDetailHelpSheet',
  components: {
    ContactUsModal,
    FunnowSvgIcon,
  },
  props: {
    order: { type: Object, default: () => ({}) },
    fromTngMiniProgram: { type: Boolean, default: false },
    isBookingEngine: { type: Boolean, default: false },
  },
  setup(props) {
    const order = computed(() => props.order)
    const { isMovie } = useOrderFlags(order)
    const isFunBookV2 = computed(() => props.order.source === OrderSource.FunBookV2)

    const showPhoneContact = computed(() => !isMovie.value && props.order.branch_phone)

    return {
      showPhoneContact,
      isFunBookPlatform: isFunBookV2,
    }
  },
  methods: {
    contactBranch() {
      window.open(`tel:${this.order.branch_phone}`, '_self')
    },
  },
})
</script>
<style lang="scss" scoped>
.order-detail-help-content {
  .content-block {
    cursor: pointer;

    &.cancel--btn {
      color: $orange50;
    }
  }
}
</style>
